/*  eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

import { Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import CircularProgress from "@material-ui/core/CircularProgress";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import TextSnippetOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import CloudDownloadOutlined from "@material-ui/icons/CloudDownloadOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import update from "immutability-helper";
import React from "react";
import { connect } from "react-redux";
import { addAttribute, loginAccount } from "../../Actions/Form";
import AuthFooter from "../Common/AuthFooter";
import AuthHeader from "../Common/AuthHeader";
import SideMenu from "../Common/SideMenu";
import AddLegacy from "./AddLegacy";
import {
    useGetAPICallQuery,
    useDeleteAPICallMutation,
} from "../../app/services/account";
import moment from "moment";
import { getTagLabel } from "../Contacts/ContactTags";
import LegacyPreview from "./Preview";
import { entityTagList, sortAscending, sortContactAscending } from "../../Utility/Utility";
import FilterContacts from "../Common/FilterContacts";

const Legacy = (props) => {
    const legacyListQuery = useGetAPICallQuery("legacy");
    const [skip, setSkip] = React.useState(true);
    const [skipMedia, setSkipMedia] = React.useState(true);
    const contactList = useGetAPICallQuery("contact", { skip: skip });
    const mediaList = useGetAPICallQuery("media", { skip: skipMedia });

    const [openPreview, setOpenPreview] = React.useState(false);
    const [previewData, setPreviewData] = React.useState({});

    const [contactFilter, setContactFilter] = React.useState([]);
    const [contactCategory, setContactCategory] = React.useState("");

    const [category, setCategory] = React.useState("");
    const changeHandler = (event) => {
        setCategory(event.target.value);
    };
    React.useEffect(() => {
        if (!legacyListQuery.isLoading && !legacyListQuery.error) {
            setSkip(false);
        }
    }, [legacyListQuery.data]);

    React.useEffect(() => {
        if (!contactList.isLoading && !contactList.error) {
            setSkipMedia(false);
        }
    }, [contactList.data]);

    React.useEffect(() => {
        if (
            mediaList.data &&
            mediaList.data.mediaList &&
            legacyListQuery.data &&
            legacyListQuery.data.legacyList &&
            contactList.data &&
            contactList.data.contactList &&
            !props.form.addLegacyFormPopup
        ) {
            let contactTags = entityTagList(sortContactAscending(contactList.data.contactList));
            let mediaTags = entityTagList(mediaList.data.mediaList);
            let legacyTags = entityTagList(legacyListQuery.data.legacyList);

            props.addAttribute({
                name: "accountData",
                value: {
                    ...props.form.accountData,
                    mediaList: sortAscending(mediaList.data.mediaList),
                    legacy: legacyListQuery.data.legacyList,
                    contactList: sortContactAscending(contactList.data.contactList),
                    contactTags: contactTags,
                    mediaTags: mediaTags,
                    legacyTags: legacyTags,
                },
            });
        }
    }, [mediaList.data && legacyListQuery.data && contactList.data]);

    const showfutureFormPopup = () => {
        props.addAttribute({
            name: "contactTreeData",
            value: [],
        });
        props.addAttribute({
            name: "selectedLegacy",
            value: null,
        });
        props.addAttribute({
            name: "addLegacyFormPopup",
            value: true,
        });
    };

    const editfutureFormPopup = (selectedLegacy) => {
        props.addAttribute({
            name: "contactTreeData",
            value: [],
        });
        props.addAttribute({
            name: "selectedLegacy",
            value: selectedLegacy,
        });

        props.addAttribute({
            name: "addLegacyFormPopup",
            value: true,
        });
    };

    const [deleteAccount, { isLoading }] = useDeleteAPICallMutation();

    const handleDelete = async (ID) => {
        await deleteAccount({
            url: `legacy/${ID}`,
            method: "DELETE",
        })
            .unwrap()
            .then((response) => {
                legacyListQuery.refetch();
            });
    };

    const getreceiversContactListID = (receiversContactListID) => {
        if (props.form.accountData && props.form.accountData.contactList) {
            let splitContact = receiversContactListID
                ? receiversContactListID.split(";")
                : [];
            let contactList = [];
            splitContact.map((item) => {
                if (item) {
                    contactList.push(item);
                    if(contactFilter.indexOf(item) < 0) {
                        setContactFilter([...contactFilter, item]);

                    }
                }
            });

            return (
                <span>
                    {contactList.map((item, index) => {
                        let currentContact =
                            props.form.accountData.contactList.filter(
                                (contact) => item == contact.system.id
                            )[0];
                        if (currentContact) {
                            return (
                                <>
                                    {currentContact &&
                                        currentContact.privateData.firstName +
                                            " " +
                                            currentContact.privateData.lastName}
                                    {index === contactList.length - 1
                                        ? ""
                                        : ", "}
                                </>
                            );
                        } else {
                            return "";
                        }
                    })}
                </span>
            );
        }
    };
    const handleChange = (panel) => (event, isExpanded) => {
        //window.scrollTo(0, 100);
        props.addAttribute({
            name: "currentLegacy",
            value: isExpanded ? panel.system.id : false,
        });
    };

    const getFileType = (desc) => {
        let format = desc.split(".");
        return format.length > 0 ? format[format.length - 1].toLowerCase() : "";
    };

    const getMediaList = (mediaListID) => {
        if (props.form.accountData && props.form.accountData?.mediaList) {
            let splitMedia = mediaListID.split(";");
            let currMediaList = [];
            splitMedia.map((item) => {
                if (item) {
                    currMediaList.push(item);
                }
            });
            return (
                <Grid container spacing={2}>
                    {currMediaList.length > 0 &&
                        currMediaList.map((item) => {
                            let currentMedia =
                                props.form.accountData.mediaList.filter(
                                    (media) => item == media.system.id
                                )
                                    ? props.form.accountData.mediaList.filter(
                                          (media) => item == media.system.id
                                      )[0]
                                    : {};
                                let fileType = currentMedia && currentMedia.data ? getFileType(currentMedia.data.originalFileName) : "";

                            return (
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className="message-grid">
                                        {currentMedia && currentMedia.data && (
                                            <React.Fragment>
                                                <div className="message-image-container">
                                                {fileType &&
                                                    (fileType === "png" ||
                                                        fileType === "jpg" ||
                                                        fileType === "jpeg" ||
                                                        fileType === "svg" ||
                                                        fileType === "gif") ? (
                                                        <img
                                                            src={currentMedia?.system?.signedUrl}
                                                            alt=""
                                                        />
                                                    )  : (fileType === "mp3" ||
                                                    fileType === "cpm" ||
                                                    fileType === "ogg" ||
                                                    fileType === "wav" ||
                                                    fileType === "aiff" ||
                                                    fileType === "acc" ||
                                                    fileType === "m4a" ||
                                                    fileType === "wma" ||
                                                    fileType === "alac") ? (
                                                      <audio style={{height: "100px", width: "160px"}} controls>
                                                          <source
                                                              src={currentMedia?.system?.signedUrl}
                                                              type="audio/ogg"
                                                          />
                                                          Your browser does not support the audio
                                                          element.
                                                      </audio>
                                                  ) : (fileType === "mp4" ||
                                                    fileType === "mov" ||
                                                    fileType === "avi" ||
                                                    fileType === "flv" ||
                                                    fileType === "wmv" ||
                                                    fileType === "webm" ||
                                                    fileType === "mpg" ||
                                                    fileType === "mp2" ||
                                                    fileType === "mpeg"
                                                    ||
                                                    fileType === "mpe" ||
                                                    fileType === "mpv" ||
                                                    fileType === "ogg" ||
                                                    fileType === "swf") ? (
                                                        <video width="160" height="160" controls>
                                                            <source src={currentMedia?.system?.signedUrl} type="video/mp4" />
                                                            Your browser does not support HTML video.
                                                        </video>
                                                    ) : (
                                                        <TextSnippetOutlinedIcon />
                                                    )}
                                                </div>
                                                <div className="message-image-desc">
                                                    <a
                                                    style={{ color: "inherit" }}
                                                    href={
                                                        currentMedia?.system
                                                            ?.signedUrl
                                                    }
                                                    target="_blank"
                                                    download
                                                >
                                                    <CloudDownloadOutlined />
                                                </a>
                                                    <div className="momentio-text-bold">
                                                        {" "}
                                                        {currentMedia.data.name}
                                                    </div>
                                                    <div className="momentio-text-normal">
                                                        {
                                                            currentMedia.meta
                                                            .additionalInfo
                                                        }
                                                    </div>
                                                    <div className="momentio-text-normal"></div>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                </Grid>
                            );
                        })}
                    {currMediaList.length === 0 && (
                        <div style={{ padding: "10px" }}></div>
                    )}
                </Grid>
            );
        }
    };

    const getBeneficiaryList = (receiversContactListID) => {

        if (props.form.accountData && props.form.accountData.contactList) {
            let splitContact = receiversContactListID
                ? receiversContactListID.split(";")
                : [];
            let contactList = [];
            splitContact.map((item) => {
                if (item) {
                    contactList.push(item);
                }
            });

            return (
                <>
                    {contactList.map((item, index) => {
                        let currentContact =
                            props.form.accountData.contactList.filter(
                                (contact) => item == contact.system.id
                            )[0];
                        if (currentContact) {
                            return (
                                <span className="shared-file" title={`${currentContact.privateData.firstName} ${currentContact.privateData.lastName}`}>
                                    {`${currentContact.privateData.firstName
                                        .slice(0, 1)
                                        .toUpperCase()}${currentContact.privateData.lastName
                                        .slice(0, 1)
                                        .toUpperCase()}`}
                                </span>
                            );
                        } else {
                            return "";
                        }
                    })}
                </>
            );
        }
        //return sharedContact
    };
    return (
        <React.Fragment>
            {props.form.addLegacyFormPopup && (
                <AddLegacy
                    open={props.form.addLegacyFormPopup}
                    //hidefutureFormPopup={hidefutureFormPopup}
                    legacyListQuery={legacyListQuery}
                />
            )}
            {(legacyListQuery.isLoading ||
                isLoading ||
                legacyListQuery.isFetching ||
                contactList.isLoading ||
                contactList.isFetching ||
                mediaList.isLoading 
                ||
                mediaList.isFetching
                ) && (
                <div className="overlay-momentio">
                    <CircularProgress
                        style={{ width: "100px", height: "100px" }}
                    />
                </div>
            )}

            <AuthHeader />
            <div className="momentio-dashboard-container">
                <SideMenu view="mysafe" />
                {openPreview && (
                    <LegacyPreview
                        setOpenPreview={() => setOpenPreview(false)}
                        row={previewData}
                    />
                )}
                {!openPreview && (
                    <div className="auth-content">
                        <div className="auth-content-subheader">
                        <div className="content-one" style={{ display: "flex", marginRight: "10px" }}>
                                <div>{props.form.language.LEGACY_TITLE}</div>
                                <span
                                    className="primary-alert-blue-sm showSM"
                                    onClick={showfutureFormPopup}
                                    style={{ marginTop: "-2px", marginLeft: "20px" }}
                                >
                                    <AddIcon />
                                </span>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                                className="files-container-column"
                            >
                                <FilterContacts contactFilter={contactFilter} setContactCategory={(item)=> setContactCategory(item)} contactCategory={contactCategory} />

                                <div className="login-field-input">
                                    <select
                                        className="filter-dropdown mm-field-input "
                                        value={category}
                                        autoComplete="off"
                                        onChange={(event) =>
                                            changeHandler(event)
                                        }
                                    >
                                        <option value="">
                                            {
                                                props.form.language
                                                    .LEGACY_FILTER_CATEGORY
                                            }
                                        </option>
                                        {props.form.accountData &&
                                        legacyListQuery.data &&
                                        legacyListQuery.data.legacyList &&
                                            props.form.accountData
                                                .legacyTags &&
                                            entityTagList(
                                                legacyListQuery.data
                                                    .legacyList
                                            ).map((opt) => {
                                                return (
                                                    <option value={opt}>
                                                        {opt}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>
                                <button
                                    className="primary-button-blue hideSM"
                                    onClick={showfutureFormPopup}
                                    style={{ textAlign: "center" }}
                                >
                                    {props.form.language.SEND_LEGACY}
                                </button>
                                
                            </div>
                        </div>

                        <div className="messages ewill">
                            <Accordion className="contactAccordion hideXS">
                                <AccordionSummary
                                    aria-controls="panel1bh-content"
                                    id="panel-moment-header"
                                    disabled={true}
                                    expandIcon={
                                        <ExpandMoreIcon
                                            style={{ visibility: "hidden" }}
                                            disabled={true}
                                        />
                                    }
                                >
                                    <Typography
                                        className="contacts-table-header"
                                        style={{
                                            paddingLeft: "20px !important",
                                        }}
                                    >
                                        <span>
                                            {props.form.language.LEGACY_TITLE_TEXT.toUpperCase()}
                                        </span>
                                    </Typography>
                                    <Typography className="contacts-table-header">
                                        <span>
                                            {
                                                props.form.language
                                                    .LEGACY_BENIFICIARY.toUpperCase()
                                            }
                                        </span>
                                    </Typography>
                                </AccordionSummary>
                            </Accordion>
                            {legacyListQuery &&
                                legacyListQuery.data &&
                                legacyListQuery.data.legacyList.map((row) => {
                                    if (
                                        (category === "" && contactCategory === "") ||
                                        ((category !== "" && row.meta.tags.includes(category)) ||
                                        (contactCategory !== "" && row.data.contactID.includes(contactCategory)) )
                                        
                                    )
                                        return (
                                            <Accordion
                                                expanded={
                                                    props.form
                                                        .currentLegacy ===
                                                    row.system.id
                                                }
                                                onChange={handleChange(row)}
                                            >
                                                <AccordionSummary
                                                    expandIcon={
                                                        <ExpandMoreIcon />
                                                    }
                                                    aria-controls="panel1bh-content"
                                                    id="panel1bh-header"
                                                    className="header-container-sm"
                                                >
                                                    <Typography className="contact-summary-header header-sm">
                                                        <span className="contactListSection mm-login-header message-title-sm">
                                                            {row.data.title}
                                                        </span>
                                                    </Typography>
                                                    <Typography className="contact-summary-header header-sm hideXS">
                                                        <span className="contactListSection message-delivery-sm">
                                                            {getBeneficiaryList(row.data.contactID)}
                                                        </span>
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails
                                                    style={{
                                                        padding:
                                                            "33px 32px 32px 32px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                        }}
                                                        className="input-container-column"
                                                    >
                                                        <div
                                                            style={{
                                                                maxWidth:
                                                                    "165px",
                                                            }}
                                                            className="momentio-text-normal accordion-content-option-label"
                                                        >
                                                            {
                                                                props.form
                                                                    .language
                                                                    .LEGACY_BENIFICIARY
                                                            }
                                                        </div>
                                                        <div
                                                            className="momentio-text-bold"
                                                            style={{
                                                                width: "70%",
                                                            }}
                                                        >
                                                            {getreceiversContactListID(
                                                                row.data
                                                                    .contactID
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                        }}
                                                        className="input-container-column"
                                                    >
                                                        <div
                                                            style={{
                                                                maxWidth:
                                                                    "165px",
                                                            }}
                                                            className="momentio-text-normal accordion-content-option-label"
                                                        >
                                                            {
                                                                props.form
                                                                    .language
                                                                    .MESSAGE_DESC
                                                            }
                                                        </div>
                                                        <div
                                                            className="momentio-text-bold"
                                                            style={{
                                                                width: "70%",
                                                                whiteSpace: "pre-wrap"
                                                            }}
                                                        >
                                                            {row.data.message}
                                                        </div>
                                                    </div>

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                        }}
                                                        className="input-container-column"
                                                    >
                                                        <div
                                                            style={{
                                                                maxWidth:
                                                                    "165px",
                                                            }}
                                                            className="momentio-text-normal accordion-content-option-label"
                                                        >
                                                            {props.form.language.CATEGORY_LABEL}
                                                        </div>
                                                        <div
                                                            className="momentio-text-bold"
                                                            style={{
                                                                width: "70%",
                                                            }}
                                                        >
                                                            {getTagLabel(
                                                                row.meta.tags,
                                                                props
                                                                
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                margin: "16px 0",
                                                            }}
                                                            className="header24Medium headerAttachment"
                                                        >
                                                            {
                                                                props.form
                                                                    .language
                                                                    .MESSAGE_ATTACHMENT
                                                            }
                                                        </div>
                                                    </div>
                                                    {getMediaList(
                                                        row.data.mediaID
                                                    )}
                                                    <div className="edit-message-icon">
                                                        <button
                                                            className="primary-button-yellow"
                                                            style={{
                                                                marginRight:
                                                                    "10px",
                                                            }}
                                                            onClick={() => {
                                                                setPreviewData(
                                                                    row
                                                                );
                                                                setOpenPreview(
                                                                    true
                                                                );
                                                                window.scrollTo(
                                                                    0,
                                                                    0
                                                                );
                                                            }}
                                                        >
                                                            {props.form.language.PREVIEW_TEXT_LEGACY}
                                                        </button>

                                                        <div
                                                            className="secondary-alert-sm"
                                                            style={{
                                                                marginRight:
                                                                    "10px",
                                                            }}
                                                            onClick={() =>
                                                                editfutureFormPopup(
                                                                    row
                                                                )
                                                            }
                                                        >
                                                            {" "}
                                                            <i className="fa fa-pencil"></i>
                                                        </div>
                                                        <div
                                                            className="secondary-alert-sm"
                                                            onClick={() =>
                                                                handleDelete(
                                                                    row.system
                                                                        .id
                                                                )
                                                            }
                                                        >
                                                            {" "}
                                                            <i className="fa fa-trash"></i>
                                                        </div>
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        );
                                })}
                        </div>
                    </div>
                )}
            </div>
            <AuthFooter />
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return { ...state };
};
const mapDispatchToProps = (dispatch) => {
    return {
        login: (payload) => dispatch(loginAccount(payload)),
        addAttribute: (payload) => dispatch(addAttribute(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Legacy);
